import { createAction } from "redux-act";

// Fetch List
const FETCH_STEERING_DATA_LIST = "FETCH_STEERING_DATA_LIST";
const FETCH_STEERING_DATA_LIST_SUCCESS = "FETCH_STEERING_DATA_LIST_SUCCESS";
const FETCH_STEERING_DATA_LIST_FAILED = "FETCH_STEERING_DATA_LIST_FAILED";

// Fetch Single Record
const FETCH_STEERING_DATA_RECORD = "FETCH_STEERING_DATA_RECORD";
const FETCH_STEERING_DATA_RECORD_SUCCESS = "FETCH_STEERING_DATA_RECORD_SUCCESS";
const FETCH_STEERING_DATA_RECORD_FAILED = "FETCH_STEERING_DATA_RECORD_FAILED";

// Create
const CREATE_STEERING_DATA = "CREATE_STEERING_DATA";
const CREATE_STEERING_DATA_SUCCESS = "CREATE_STEERING_DATA_SUCCESS";
const CREATE_STEERING_DATA_FAILED = "CREATE_STEERING_DATA_FAILED";

// Update
const UPDATE_STEERING_DATA = "UPDATE_STEERING_DATA";
const UPDATE_STEERING_DATA_SUCCESS = "UPDATE_STEERING_DATA_SUCCESS";
const UPDATE_STEERING_DATA_FAILED = "UPDATE_STEERING_DATA_FAILED";

// Delete
const DELETE_STEERING_DATA = "DELETE_STEERING_DATA";
const DELETE_STEERING_DATA_SUCCESS = "DELETE_STEERING_DATA_SUCCESS";
const DELETE_STEERING_DATA_FAILED = "DELETE_STEERING_DATA_FAILED";

// Loading / Error
const SET_STEERING_DATA_LOADING = "SET_STEERING_DATA_LOADING";
const SET_STEERING_DATA_ERROR = "SET_STEERING_DATA_ERROR";

// Fetch List
export const fetchSteeringDataList = createAction(FETCH_STEERING_DATA_LIST);
export const fetchSteeringDataListSuccess = createAction(
    FETCH_STEERING_DATA_LIST_SUCCESS,
    (payload) => payload
);
export const fetchSteeringDataListFailed = createAction(
    FETCH_STEERING_DATA_LIST_FAILED,
    (payload) => payload
);

// Fetch Single Record
export const fetchSteeringDataRecord = createAction(FETCH_STEERING_DATA_RECORD);
export const fetchSteeringDataRecordSuccess = createAction(
    FETCH_STEERING_DATA_RECORD_SUCCESS,
    (payload) => payload
);
export const fetchSteeringDataRecordFailed = createAction(
    FETCH_STEERING_DATA_RECORD_FAILED,
    (payload) => payload
);

// Create
export const createSteeringData = createAction(CREATE_STEERING_DATA, (payload) => payload);
export const createSteeringDataSuccess = createAction(
    CREATE_STEERING_DATA_SUCCESS,
    (payload) => payload
);
export const createSteeringDataFailed = createAction(
    CREATE_STEERING_DATA_FAILED,
    (payload) => payload
);

// Update
export const updateSteeringData = createAction(UPDATE_STEERING_DATA, (payload) => payload);
export const updateSteeringDataSuccess = createAction(
    UPDATE_STEERING_DATA_SUCCESS,
    (payload) => payload
);
export const updateSteeringDataFailed = createAction(
    UPDATE_STEERING_DATA_FAILED,
    (payload) => payload
);

// Delete
export const deleteSteeringData = createAction(DELETE_STEERING_DATA, (payload) => payload);
export const deleteSteeringDataSuccess = createAction(
    DELETE_STEERING_DATA_SUCCESS,
    (payload) => payload
);
export const deleteSteeringDataFailed = createAction(
    DELETE_STEERING_DATA_FAILED,
    (payload) => payload
);

// Loading / Error
export const setSteeringDataLoading = createAction(
    SET_STEERING_DATA_LOADING,
    (payload: boolean) => payload
);
export const setSteeringDataError = createAction(
    SET_STEERING_DATA_ERROR,
    (payload: string | null) => payload
);
